import request from './request.js';
import {requestbody} from './request.js'

//查询
export async function shlc_page(params = {

}) {
    return await requestbody('oa/flowCenter/page', 'get', params)
}
//保存
export async function shlc_save(params = {

}) {
    return await requestbody('oa/flowCenterExt/save', 'post', params)
}

//查询角色
export async function shlc_selectRoleUserList(params = {

}) {
    return await requestbody('oa/flowCenterExt/selectRoleUserList', 'post', params)
}

//查询所有公司
export async function queryAllCompanys (params = {
    
}) {
    return await requestbody('sys/getAllCompanys', 'post', params)
}